import React, { type ReactNode } from "react";

import { PressCard } from "./press_card";
// Used to show an example of the post
// on the admin side of the house

const PressCardExample = (): ReactNode => {
  const examplePressItem = {
    tagline: "The tagline",
    headline: "The headline goes here",
    description: "Here's where we put the description",
    publishedDate: "2024-10-15",
    source: "The Source goes here",
    link: "",
  };
  return (
    <section>
      <p>
        Here's an example showing where all these parts fit into what we display
        on the site.
      </p>
      <PressCard pressItem={examplePressItem} />
    </section>
  );
};

export { PressCardExample };
